import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "isDark", "dark", "onSwitch", "noInactiveColor", "className", "htmlProps"];
import cn from 'classnames';
import transition from "../styles/transition";
import { jsx as _jsx } from "react/jsx-runtime";
var Switch = function Switch(_ref) {
  var checked = _ref.checked,
    isDark = _ref.isDark,
    dark = _ref.dark,
    onSwitch = _ref.onSwitch,
    _ref$noInactiveColor = _ref.noInactiveColor,
    noInactiveColor = _ref$noInactiveColor === void 0 ? false : _ref$noInactiveColor,
    className = _ref.className,
    htmlProps = _ref.htmlProps,
    switchProps = _objectWithoutProperties(_ref, _excluded);
  var buttonBg = checked || noInactiveColor ? 'bg-primary-main' : 'bg-gray-main';
  if (isDark || dark) {
    buttonBg = checked || noInactiveColor ? 'bg-secondary-light' : 'bg-gray-dark';
  }
  var renderIndicator = function renderIndicator() {
    return /*#__PURE__*/_jsx("div", {
      className: "flex items-center justify-center w-20 h-20 rounded-full bg-white",
      style: {
        transform: "translateX(".concat(checked ? '24px' : 0, ")"),
        transition: transition('transform')
      }
    });
  };
  var props = _objectSpread({
    className: cn('w-48 h-24 focus:outline-none', buttonBg, className),
    style: {
      borderRadius: '45px',
      padding: '2px',
      transition: transition('background-color')
    }
  }, switchProps);
  if (onSwitch) {
    return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
      type: "button",
      onClick: function onClick(event) {
        event.preventDefault();
        onSwitch(!checked);
      }
    }, props), htmlProps), {}, {
      children: renderIndicator()
    }));
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({}, props), htmlProps), {}, {
    children: renderIndicator()
  }));
};
export default Switch;